export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false

  const userAgent = window.navigator.userAgent.toLowerCase()
  const mobileKeywords = [
    'mobile',
    'android',
    'iphone',
    'ipad',
    'tablet',
    'kindle',
    'firefox os',
    'webos',
    'blackberry',
    'windows phone',
  ]

  return mobileKeywords.some((keyword) => userAgent.includes(keyword))
}

export const isTabletDevice = (): boolean => {
  if (typeof window === 'undefined') return false

  const userAgent = window.navigator.userAgent.toLowerCase()
  // iPadOS 13+ の Safari は既定で「デスクトップ用サイト」を要求し、UA が
  // Macintosh になる。タッチポイント数で実体がタブレットであることを見分ける。
  const isIpadDesktopUa =
    userAgent.includes('macintosh') && window.navigator.maxTouchPoints > 1
  // Android タブレットは UA に 'android' を含み 'mobile' を含まない。
  const isAndroidTablet =
    userAgent.includes('android') && !userAgent.includes('mobile')
  const tabletKeywords = ['ipad', 'tablet', 'kindle', 'playbook', 'silk']

  return (
    isIpadDesktopUa ||
    isAndroidTablet ||
    tabletKeywords.some((keyword) => userAgent.includes(keyword))
  )
}

export const isPcDevice = (): boolean => {
  if (typeof window === 'undefined') return false
  // iPadOS のデスクトップ UA（Macintosh）等、タブレット実体は PC 扱いしない。
  if (isTabletDevice()) return false

  const userAgent = window.navigator.userAgent.toLowerCase()
  const isChromeOS = userAgent.includes('cros')
  const isWindows = userAgent.includes('windows')
  const isMac = userAgent.includes('macintosh')
  const isLinux = userAgent.includes('linux') && !userAgent.includes('android')

  return isChromeOS || isWindows || isMac || isLinux
}

export const isSupportedDevice = (): boolean => {
  return isPcDevice()
}
